import client from "./axiosConfig";

export const updateUser = (values) => {
    const config = {
        url: "/users/",
        method: "PUT",
        data: values,
    };
    const response = client(config);
    return response;
};

export const getUser = () => {
    const config = {
        url: "/users/",
        method: "GET",
    };
    const response = client(config);
    return response;
};

export const getAllUser = (params) => {
    const config = {
        url: "/users/all/",
        method: "GET",
        params
    };
    const response = client(config);
    return response;
}

export const updateUserRole = (data) => {
    const config = {
        url: `/users/review/`,
        method: "PATCH",
        data
    };
    const response = client(config);
    return response;
}

export const deleteUser = (id) => {
    const config = {
        url: `/users/delete/${id}/`,
        method: "DELETE"
    }
    const response = client(config);
    return response;
}
